import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[web-content]',
  standalone: false
})
export class WebContentDirective {

  constructor(private el: ElementRef) {
    this.el.nativeElement.classList.add('web-content');
  }

}
